import styled from "styled-components";
import {
  Title,
  Body,
  FormItem as SundayFormItem,
  OtpInput,
  Headline,
} from "sunday-component";
import { Image, Modal as M, Row } from "antd";
import { color } from "src/styles/globals";
import { CheckOutlined as Cl } from "@ant-design/icons";
import { down } from "styled-breakpoints";
import LinkTitle from "../../Common/LinkTitle";
import Button from "../../Common/Button";

const maxContentWidth = "343px";

export const CheckOutlined = styled(Cl)`
  color: #1c7c4e;
  font-weight: bold;
  font-size: 17px;
  line-height: 18px;
`;

export const Verified = styled(Title).attrs({ level: 9 })`
  margin-left: 10px;
  color: #1c7c4e;
`;

export const SendOtpButton = styled(Button)`
  max-height: 48px;
  width: 100%;
  padding: 0px;
`;

export const SubmitOtpButton = styled(Button)`
  max-height: 48px;
  width: 100%;
  padding: 0px;
  ${down("lg")} {
    max-width: ${maxContentWidth};
    margin: 0 auto;
  }
`;

export const FormItem = styled(SundayFormItem)`
  margin: 0px;
`;

export const Space = styled.div`
  margin-top: 122px;
`;

export const Modal = styled(M)`
  max-width: 444px;
  .ant-modal-content {
    border-radius: 16px;
  }
  .ant-modal-header {
    border-radius: 16px 16px 0px 0px;
  }
  .ant-modal-close {
    margin-top: 8px;
  }
  .ant-modal-body {
    padding: 0px;
  }
  .ant-modal-close {
    color: red;
  }
  ${down("lg")} {
    top: 0;
    margin: 0px;
    padding: 0px;
    .ant-modal,
    .ant-modal-content {
      height: 100vh;
      width: 100vw;
      margin: 0;
      top: 0;
    }
    .ant-modal-footer {
      display: flex;
      padding: 16px;
      position: fixed;
      bottom: 0;
      width: 100%;
      background: white;
    }
    .ant-modal-content {
      border-radius: 0px;
    }
    .ant-modal-body {
      overflow: auto;
      padding: 0px;
      width: 100vw;
      height: calc(100vh - 141px);
    }
  }
`;

export const Content = styled.div`
  padding: 24px 16px 24px 16px;
  ${down("lg")} {
    max-width: ${maxContentWidth};
    margin: auto;
  }
`;

export const OtpBannerBg = styled.div`
  background-image: url("/static/pages/registerOtp/register-otp-banner-bg.svg");
  background-repeat: no-repeat;
  background-size: cover;
  height: 200px;
  border-radius: 0% 0% 100% 100% / 0% 0% 20% 20%;
  overflow: hidden;
  position: relative;
  padding: 0 16px;
  ${down("lg")} {
    height: 155px;
  }
`;

export const OtpBanner = styled.div`
  margin: auto;
  margin-top: 36px;
  ${down("lg")} {
    margin-top: 0px;
    max-width: ${maxContentWidth};
  }
`;

export const OtpBannerImage = styled.div`
  height: 175px;
  position: absolute;
  ${down("lg")} {
    height: 130px;
    bottom: -8px;
  }
`;

export const OtpBannerContent = styled.div`
  margin-left: auto;
  width: fit-content;
  height: 100%;
  align-content: center;
  ${down("lg")} {
    padding: 24px 16px;
  }
`;

export const BannerTitle = styled(Headline).attrs({ level: 6 })`
  color: ${color.white};
`;

export const BannerSubtitle = styled(Body).attrs({ level: 6 })`
  color: ${color.white};
  margin-top: 6px;
`;

export const ModalTitle = styled(Title).attrs({ level: 5 })`
  position: relative;
  text-align: center;
  color: ${color.charcoal10};
`;

export const ModalCloseIcon = styled.div`
  position: absolute;
  display: flex;
  items: center;
  width: 24px;
  height: 100%;
  right: 0;
  top: 0;
`;

export const CloseIcon = styled(Image)`
  cursor: pointer;
`;

export const SubtitleBody = styled(Body).attrs({ level: 7 })`
  display: grid;
  gap: 4px;
  color: ${color.charcoal09};
`;

export const SubtitleBold = styled(Title).attrs({ level: 7 })``;

export const InputRow = styled(Row)`
  margin-top: 24px;
  margin-bottom: 24px;
  max-height: fit-content;
`;

export const ButtonTitle = styled(Title)``;

export const EditButton = styled(LinkTitle).attrs({ level: 7 })`
  cursor: pointer;
`;

export const ResendButton = styled(LinkTitle).attrs({ level: 7 })`
  margin-top: 4px;
  cursor: pointer;
`;

export const ResendWait = styled(Title).attrs({ level: 7 })`
  color: ${color.charcoal09};
  margin-top: 4px;
`;

export const OtpField = styled(OtpInput)`
  background: ${color.errorRed01};
`;

export const OtpFieldContainer = styled(SundayFormItem)`
  margin: 0px;
  .sunday-component-form-item-control {
    row-gap: 8px;
  }
  .sunday-component-form-item-control-input-content > div > div > div > input {
    width: 100% !important;
    font-size: 27px;
    weight: 700;
    caret-color: ${color.carrotOrange};
  }
  .sunday-component-form-item-control-input-content
    > div
    > div
    > div
    > input:focus {
    border-color: ${color.carrotOrange};
  }
  .sunday-component-form-item-control-input-content
    > div
    > div
    > div
    > input::selection {
    color: inherit;
    background: none;
  }
`;
